import React from 'react';
import PricingPage from '../../Company/Pricing/PricingPage';
import MetaTags from '../../../helpers/Common/MetaTags';
import { getMetaConfig } from '../../../helpers/Common/metaConfig';

const Pricing = () => {
    const pricingMeta = getMetaConfig('pricing');
    
    return (
        <React.Fragment>
            <MetaTags {...pricingMeta} />
            <PricingPage/>
        </React.Fragment>
    )
}

export default Pricing
